import dayjs from 'dayjs'

export const isPhoneNumberValid = (s: string) => {
  return /^[\+]?[0-9*]{0,20}$/.test(s)
}

export const isDateValid = (date: string) => {
  // Check if date is empty
  if (!date) {
    return true
  }
  const dateRegex = /^\d{2}\.\d{2}\.\d{4}$/
  if (!dateRegex.test(date)) {
    return false
  }
  const [dayStr, monthStr, yearStr] = date.split('.')
  const day = Number(dayStr)
  const month = Number(monthStr)
  const year = Number(yearStr)
  if (!day || day < 1 || day > 31) return false
  if (!month || month < 1 || month > 12) return false
  const currentYear = dayjs().year()
  if (!year || year > currentYear || year < 1900) return false
  const daysInMonth = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
  if (month === 2) {
    const isLeapYear = (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0)
    const maxDays = isLeapYear ? 29 : 28
    if (day > maxDays) return false
  } else {
    if (day > (daysInMonth[month ?? 0] ?? 0)) return false
  }
  return true
}

export const isEmailValid = (email: string | undefined) => {
  if (!email || email.trim() === '') {
    return false
  }
  const trimmedEmail = email.trim()
  if (trimmedEmail.includes(' ') ||
      trimmedEmail.startsWith('.') ||
      trimmedEmail.startsWith('@') ||
      trimmedEmail.endsWith('.') ||
      trimmedEmail.endsWith('@') ||
      !trimmedEmail.includes('@') ||
      trimmedEmail.split('@').length !== 2) {
    return false
  }
  if (trimmedEmail.includes('..')) {
    return false
  }

  const [localPart, domain] = trimmedEmail.split('@')
  if (!localPart || localPart.length === 0) {
    return false
  }
  if (!domain || domain.length === 0 || !domain.includes('.')) {
    return false
  }
  if (domain.startsWith('.') || domain.startsWith('-') ||
      domain.endsWith('.') || domain.endsWith('-')) {
    return false
  }
  const localPartRegex = /^[a-zA-Z0-9._%+-]+$/
  if (!localPartRegex.test(localPart)) {
    return false
  }
  const domainRegex = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  if (!domainRegex.test(domain)) {
    return false
  }
  const domainParts = domain.split('.')
  if (domainParts.length < 2 || domainParts[0]?.length === 0) {
    return false
  }
  for (const part of domainParts) {
    if (part.endsWith('-')) {
      return false
    }
  }
  return true
}
